import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';

import { Tooltip } from 'antd';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import { formatNumber } from '../../../../utils/validation';
import geo from './geo.json';
interface MarkerData {
    name: string;
    key: string;
    investment: string;
}

interface WorldMapProps {
    data: MarkerData[];
    isPdf?: boolean;
}

const WorldMap: React.FC<WorldMapProps> = ({ data = [], isPdf }) => {
    const [openTooltip, setOpenTooltip] = useState<string | number | null>('Singapore');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const countryCoordinates = useSelector((state: RootState) => state.constants.constants.countries) || [];

    const transformedCoordinates = useMemo(() => {
        return countryCoordinates.reduce((acc, item) => {
            const keys = item.name.replace(/\s+/g, '').toLowerCase();
            const data: any = item.coordinates.reverse();
            acc[keys] = data;
            return acc;
        }, {} as { [key: string]: [number, number] });
    }, [countryCoordinates]);

    return (
        <div className="p-4 h-full bg-white ">
            <div className="flex flex-col justify-between gap-2 h-full">
                <p className="WorkSans-Semibold font-semibold text-sm text-[#152C52] text-left">
                    By Geography (in USD)
                </p>{' '}
                <ComposableMap viewBox="50 50 800 450">
                    <defs>
                        <pattern id="dotted-pattern" x="0" y="0" width="4" height="4" patternUnits="userSpaceOnUse">
                            <path
                                d="M5.49317 5.28722H2.40713L0.908203 2.83599L2.40713 0.384766H5.49317L7.03619 2.83599L5.49317 5.28722Z"
                                fill="#27AE60"
                                stroke="#27AE60"
                                width={2}
                                height={2}
                            />
                        </pattern>
                    </defs>

                    <Geographies geography={geo}>
                        {(props: any) =>
                            props?.geographies.map((geo: any) => (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    fill="url(#dotted-pattern)"
                                    data-tooltip-content={geo.properties.name}
                                    stroke="#FFF"
                                />
                            ))
                        }
                    </Geographies>
                    {data.map(({ name, key, investment }) => {
                        const coordinates: [number, number] | undefined | [] =
                            transformedCoordinates[String(key).replace(/\s+/g, '').toLowerCase()];

                        if (!coordinates) {
                            return null;
                        }

                        return (
                            <Tooltip
                                key={name}
                                color="white"
                                open={openTooltip === key}
                                overlayInnerStyle={{
                                    backgroundColor: 'white',
                                    // border: '1px solid #152C52',
                                    // borderRadius: '5px',
                                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                    color: '#152C52',
                                    padding: 0,
                                }}
                                title={
                                    <div className="bg-white p-2">
                                        <div className="text-sm text-[#142C53] font-[WorkSans-SemiBold]">
                                            {formatNumber(parseInt(investment) || 0)}
                                        </div>
                                        <div className="text-[7px] text-[#142C53] font-[WorkSans]">{name}</div>
                                    </div>
                                }
                            >
                                <Marker key={name} coordinates={coordinates}>
                                    <circle
                                        r={4}
                                        fill="#152C52"
                                        stroke="#FFF"
                                        strokeWidth={2}
                                        data-tip={`${name}: ${investment}`}
                                        onMouseEnter={() => setOpenTooltip(key)}
                                        className="cursor-pointer"
                                        // onMouseLeave={() => setOpenTooltip(null)}
                                    />
                                </Marker>
                            </Tooltip>
                        );
                    })}
                </ComposableMap>
                <div className={isPdf ? 'grid lg:grid-cols-4' : 'grid lg:grid-cols-6 md:grid-cols-6 grid-cols-4'}>
                    {data
                        .sort((a: any, b: any) => b.investment - a.investment)
                        .map(({ name, investment }) => {
                            return (
                                <div>
                                    {' '}
                                    <div className="text-xs text-[#142C53] font-[WorkSans-SemiBold]">
                                        {formatNumber(parseInt(investment) || 0)}
                                    </div>
                                    <div className="text-[7px] text-[#142C53] font-[WorkSans]">{name}</div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
};

export default WorldMap;
